export function backToTop() {
  const dom = {
    buttonEl: null,
  };

  function init() {
    loadDom();
    handleClick();
    handleVisbility();
  }

  function loadDom() {
    dom.buttonEl = document.querySelector(".back-to-top");
  }

  function handleVisbility() {
    if (!dom.buttonEl) return;

    window.addEventListener("scroll", function () {
      if (window.scrollY > 200) {
        dom.buttonEl.dataset.stateVisible = "true";
      } else {
        dom.buttonEl.dataset.stateVisible = "false";
      }
    });
  }

  function handleClick() {
    if (!dom.buttonEl) return;

    dom.buttonEl.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  return {
    init,
  };
}
